import { render } from "./PushCreateHeader.vue?vue&type=template&id=551d35c8&scoped=true"
import script from "./PushCreateHeader.vue?vue&type=script&lang=js"
export * from "./PushCreateHeader.vue?vue&type=script&lang=js"

import "./PushCreateHeader.vue?vue&type=style&index=0&id=551d35c8&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-551d35c8"]])

export default __exports__